'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createLogger;

var _reduxLogger = require('redux-logger');

function createLogger(shouldLog) {
    return (0, _reduxLogger.createLogger)({
        collapsed: true,
        predicate: shouldLog ? null : false
    });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/logger/clientLogger.js
// module id = Sr01
// module chunks = 57